import { Add, Remove } from "@mui/icons-material";
import {
  Button,
  FormControl,
  FormLabel,
  IconButton,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import MuiInput from "@mui/material/Input";
import Slider from "@mui/material/Slider";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import * as React from "react";
import { useActividadesContext } from "../../UmmIACategories/Hook/useActividades";
import plusIcon from "../img/PlusIcon.svg";
import ResumenTipoPreguntas from "./ResumenTipoPreguntas";

const Input = styled(MuiInput)`
  width: 42px;
`;

export default function AgregarTipoPreguntas({ setIsPreguntaAdded }) {
  const { promptData, setPromptData } = useActividadesContext();
  
  // Aseguramos que promptData.preguntas sea un array
  const [tipoPreguntas, setTipoPreguntas] = React.useState(
    Array.isArray(promptData.preguntas) ? promptData.preguntas : []
  );
  // Usamos nuevaPregunta para el valor del Slider y TextField
  const [nuevaPregunta, setNuevaPregunta] = React.useState({
    tipo_preguntas: "",
    cantidad_preguntas: 1,
  });

  // Cada vez que cambia la cantidad en nuevaPregunta, se actualiza promptData para mantenerlos sincronizados
  React.useEffect(() => {
    setPromptData((prevData) => ({
      ...prevData,
      cantidad_preguntas: nuevaPregunta.cantidad_preguntas,
    }));
  }, [nuevaPregunta.cantidad_preguntas, setPromptData]);

  // Actualizamos promptData cada vez que cambia tipoPreguntas
  React.useEffect(() => {
    actualizarPromptData(tipoPreguntas);
  }, [tipoPreguntas]);

  // Inicializamos el estado tipoPreguntas cuando el componente se monta
  React.useEffect(() => {
    setTipoPreguntas(
      Array.isArray(promptData.preguntas) ? promptData.preguntas : []
    );
  }, [promptData]);

  

  const agregarPregunta = () => {
    const nuevasPreguntas = [...tipoPreguntas, nuevaPregunta];
    setTipoPreguntas(nuevasPreguntas);
    setNuevaPregunta({ tipo_preguntas: "", cantidad_preguntas: 1 });
    setIsPreguntaAdded(true)
  };

  const eliminarPregunta = (index) => {
    const nuevasPreguntas = tipoPreguntas.filter((_, i) => i !== index);
    setTipoPreguntas(nuevasPreguntas);
    if (nuevasPreguntas.length === 0) {
    setIsPreguntaAdded(false); 
  }
  };

  const handleTipoChange = (event) => {
    setNuevaPregunta({ ...nuevaPregunta, tipo_preguntas: event.target.value });
  };

  const handleCantidadChange = (event, newValue) => {
    setNuevaPregunta({ ...nuevaPregunta, cantidad_preguntas: newValue });
    setPromptData((prevData) => ({
      ...prevData,
      cantidad_preguntas: newValue,
    }));
  };

  const handleInputChange = (event) => {
    const inputValue = event.target.value;
    const newValue = inputValue === "" ? 1 : Number(inputValue);
    setNuevaPregunta((prev) => ({ ...prev, cantidad_preguntas: newValue }));
    setPromptData((prevData) => ({
      ...prevData,
      cantidad_preguntas: newValue,
    }));
  };

  const handleIncrement = () => {
    setNuevaPregunta((prev) => {
      const newValue = Math.min(prev.cantidad_preguntas + 1, 15);
      setPromptData((prevData) => ({
        ...prevData,
        cantidad_preguntas: newValue,
      }));
      return { ...prev, cantidad_preguntas: newValue };
    });
  };

  const handleDecrement = () => {
    setNuevaPregunta((prev) => {
      const newValue = Math.max(prev.cantidad_preguntas - 1, 1);
      setPromptData((prevData) => ({
        ...prevData,
        cantidad_preguntas: newValue,
      }));
      return { ...prev, cantidad_preguntas: newValue };
    });
  };

  const actualizarPromptData = (nuevasPreguntas) => {
    setPromptData((prevData) => ({
      ...prevData,
      preguntas: nuevasPreguntas,
    }));
  };

  return (
    <>
      <Grid container spacing={1}>
        {/* Columna izquierda: Agregar tipo de preguntas */}
        <Grid item xs={12} md={6}>
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Typography
              sx={{
                fontFamily: "montserrat",
                fontSize: "1.25rem",
                fontWeight: "bold",
                color: "#336B87",
              }}
            >
              Agregar tipo de preguntas *
            </Typography>
            <FormLabel
              component="p"
              sx={{ fontFamily: "montserrat", fontSize: "0.85rem", mt: 0.2 }}
            >
              Selecciona para cada tipo la cantidad de preguntas que quieres
              incluir en la evaluación
            </FormLabel>
          </Box>
          <FormControl sx={{ width: "80%", mt: 1, mr: 2 }}>
            <Select
              labelId="select-tipo-pregunta"
              id="select-tipo-pregunta"
              variant="outlined"
              value={nuevaPregunta.tipo_preguntas}
              onChange={handleTipoChange}
              sx={{
                borderRadius: 2,
                fontFamily: "montserrat",
                mb: 2,
                fontSize: "14px",
                color: "#336B87",
                "& fieldset": { borderColor: "#Divider" },
                "&:before": { borderColor: "#Divider" },
                "&:after": { borderColor: "#Divider" },
              }}
              InputProps={{
                sx: {
                  borderRadius: 2,
                  mt: 1,
                  mb: 3,
                  fontFamily: "montserrat",
                  fontSize: "14px",
                  color: "#336B87",
                },
              }}
            >
              <MenuItem value="Verdadero o falso" sx={{ color: "#336B87" }}>
                <Typography
                  sx={{ fontFamily: "montserrat", fontSize: "0.8rem" }}
                >
                  Verdadero o falso
                </Typography>
              </MenuItem>
              <MenuItem value="Selección múltiple" sx={{ color: "#336B87" }}>
                <Typography
                  sx={{ fontFamily: "montserrat", fontSize: "0.8rem" }}
                >
                  Selección múltiple
                </Typography>
              </MenuItem>
              <MenuItem value="Preguntas abiertas" sx={{ color: "#336B87" }}>
                <Typography
                  sx={{ fontFamily: "montserrat", fontSize: "0.8rem" }}
                >
                  Preguntas abiertas
                </Typography>
              </MenuItem>
            </Select>
          </FormControl>
        </Grid>

        {/* Columna derecha: Cantidad de preguntas */}
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          spacing={2}
          sx={{ width: 600 }}
        >
          {/* Grupo del slider (incluye título y slider) */}
          <Grid item xs={8}>
            <Typography
              sx={{
                fontFamily: "montserrat",
                fontSize: "1.25rem",
                fontWeight: "bold",
                color: "#336B87",
              }}
            >
              Cantidad de preguntas *
            </Typography>
            <Slider
              value={nuevaPregunta.cantidad_preguntas}
              onChange={handleCantidadChange}
              aria-labelledby="cantidad-preguntas-slider"
              color="success"
              valueLabelDisplay="auto"
              marks={[
                { value: 1, label: "1 pregunta" },
                { value: 15, label: "15 preguntas" },
              ]}
              min={1}
              max={15}
              sx={{
                color: "#336B87",
                mt: 4,
                ml: 5,
                "& .MuiSlider-markLabel": {
                  color: "#336B87",
                  fontFamily: "montserrat",
                },
                "& .MuiSlider-valueLabel": {
                  backgroundColor: "#F9DA96",
                  color: "#209099",
                  fontFamily: "montserrat",
                },
              }}
            />
          </Grid>

          {/* Grupo del TextField con botones de incremento y decremento */}
          <Grid item xs={4}>
            <Grid container alignItems="center" spacing={1} marginLeft={4}>
              <Grid item>
                <IconButton
                  onClick={handleDecrement}
                  disabled={nuevaPregunta.cantidad_preguntas <= 1}
                >
                  <Remove />
                </IconButton>
              </Grid>
              <Grid item>
                <TextField
                  variant="standard"
                  value={nuevaPregunta.cantidad_preguntas}
                  onChange={handleInputChange}
                  inputProps={{
                    step: 1,
                    min: 1,
                    max: 15,
                    type: "text",
                    style: {
                      textAlign: "center",
                      fontFamily: "montserrat",
                      color: "#336B87",
                    },
                  }}
                  sx={{
                    width: 40,
                    textAlign: "center",
                    fontFamily: "montserrat",
                    color: "#336B87",
                  }}
                />
              </Grid>
              <Grid item>
                <IconButton
                  onClick={handleIncrement}
                  disabled={nuevaPregunta.cantidad_preguntas >= 15}
                >
                  <Add />
                </IconButton>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {/* Fila completa para el resumen de preguntas */}
      </Grid>
      <Grid item xs={12}>
        <ResumenTipoPreguntas
          tipoPreguntas={tipoPreguntas}
          eliminarPregunta={eliminarPregunta}
        />
      </Grid>
      <Grid item display={"flex"} justifyContent={"end"}>
        <Button
          variant="contained"
          color="primary"
          onClick={agregarPregunta}
          disabled={!nuevaPregunta.tipo_preguntas}
          sx={{
            borderRadius: 20,
            fontSize: "0.9rem",
            fontFamily: "Montserrat",
            fontWeight: "bold",
            backgroundColor: "#F9DA96",
            "&:hover": { backgroundColor: "#F9DA97" },
            color: "#336B87",
            mt: 2,
          }}
          startIcon={
            <Box
              sx={{
                width: 24,
                height: 24,
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img
                src={plusIcon}
                alt="Icono"
                style={{ width: "25px", height: "25px" }}
              />
            </Box>
          }
        >
          Agregar
        </Button>
      </Grid>
    </>
  );
}
